// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_HANDMADE_PRODUCT_HOVER = "Vlastn\u00ed v\u00fdroba";
export const BZ2_NEW_PRODUCT_HOVER = "Nov\u00e9 zbo\u017e\u00ed";
export const BZ2_OLD_PRODUCT_HOVER = "Pou\u017eit\u00e9 zbo\u017e\u00ed";
export const BZ2_SERVICES_PRODUCT_HOVER = "Slu\u017eby";
